import { render, staticRenderFns } from "./IconButtonEllipsisH.vue?vue&type=template&id=41aa1865&scoped=true&"
import script from "./IconButtonEllipsisH.vue?vue&type=script&lang=js&"
export * from "./IconButtonEllipsisH.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonEllipsisH.vue?vue&type=style&index=0&id=41aa1865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa1865",
  null
  
)

export default component.exports